
















































import { Component, Vue } from "vue-property-decorator";
import HomeInformationCard from "@/components/home/HomeInformationCard.vue";

@Component({
    components: { HomeInformationCard }
})
export default class HomeInformation extends Vue {
    /**
     * Images
     */
    images = {
        peter: require("@/assets/img/home/peter.jpg?size=200"),
        clublokaal: require("@/assets/img/home/cafe.jpg?size=200")
    };
}
